var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "rank-page",
      style: { background: !_vm.isHidden ? "#24252A" : "#fff" }
    },
    [
      _vm.isHidden
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "my-loading",
                  rawName: "v-my-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              staticClass: "no-rank flex column"
            },
            [
              _c(
                "van-empty",
                {
                  staticClass: "custom-image",
                  attrs: { description: _vm.$t("300108") }
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "icon",
                      attrs: { slot: "image", "aria-hidden": "true" },
                      slot: "image"
                    },
                    [_c("use", { attrs: { "xlink:href": "#icon-jilu1" } })]
                  )
                ]
              ),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("300116")))])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isHidden
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "my-loading",
                  rawName: "v-my-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ]
            },
            [
              _c(
                "div",
                {
                  staticClass: "rank-banner",
                  style: { backgroundImage: "url(" + _vm.bannerUrl + ")" }
                },
                [
                  _c("h1", [_vm._v(_vm._s(_vm.$t("300067")))]),
                  _vm._v(" "),
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.$t("300068")) }
                  }),
                  _vm._v(" "),
                  _c(
                    "van-button",
                    {
                      attrs: { color: "#FFC72B" },
                      on: { click: _vm.handleShare }
                    },
                    [_vm._v(_vm._s(_vm.$t("300069")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "rank-container" }, [
                _c(
                  "div",
                  { attrs: { id: "rank" } },
                  [
                    _c("div", { staticClass: "title" }, [
                      _c("div", { staticClass: "flex-center" }, [
                        _c(
                          "svg",
                          {
                            staticClass: "icon",
                            attrs: { slot: "image", "aria-hidden": "true" },
                            slot: "image"
                          },
                          [
                            _c("use", {
                              attrs: { "xlink:href": "#icon-paihangbang" }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("h1", { staticClass: "bold" }, [
                          _vm._v(_vm._s(_vm.$t("300070")))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "block" }, [
                        _vm._v(_vm._s(_vm.$t("300073")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "tabs flex-center" },
                      _vm._l(_vm.rankTabList, function(item) {
                        return _c(
                          "li",
                          {
                            key: item.value,
                            staticClass: "tab-item bold pointer",
                            class: { active: _vm.rankActiveId == item.value },
                            on: {
                              click: function($event) {
                                return _vm.changeRankTab(item)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t(item.label)) + "\n          ")]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("van-notice-bar", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            (_vm.rankActiveId == "day" && _vm.dailyMsg) ||
                            (_vm.rankActiveId == "total" && _vm.totalMsg),
                          expression:
                            "(rankActiveId == 'day' && dailyMsg )|| (rankActiveId == 'total' && totalMsg)"
                        }
                      ],
                      attrs: {
                        scrollable: "",
                        color: "#FFC72B",
                        background: "#fff",
                        text:
                          _vm.rankActiveId == "day"
                            ? _vm.dailyMsg
                            : _vm.totalMsg
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "rank-table" }, [
                      _c("div", { staticClass: "thead flex-between" }, [
                        _c("span", { staticClass: "th" }, [
                          _vm._v(_vm._s(_vm.$t("300084")))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "th" }, [
                          _vm._v(_vm._s(_vm.$t("300085")))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "th" }, [
                          _vm._v(_vm._s(_vm.$t("300086")) + "(USDT)")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          directives: [
                            {
                              name: "my-loading",
                              rawName: "v-my-loading",
                              value: _vm.rankLoading,
                              expression: "rankLoading"
                            }
                          ],
                          staticClass: "tbody"
                        },
                        [
                          _vm._l(_vm.rankList.slice(0, _vm.len), function(
                            item
                          ) {
                            return _c(
                              "li",
                              {
                                key: item.id + "a",
                                staticClass: "tr flex-between",
                                class: {
                                  firstBg: item.id == 1,
                                  secondBg: item.id == 2,
                                  thirdBg: item.id == 3
                                }
                              },
                              [
                                _c("span", { staticClass: "td" }, [
                                  item.id == 1
                                    ? _c(
                                        "svg",
                                        {
                                          staticClass: "icon",
                                          attrs: {
                                            slot: "image",
                                            "aria-hidden": "true"
                                          },
                                          slot: "image"
                                        },
                                        [
                                          _c("use", {
                                            attrs: {
                                              "xlink:href": "#icon-diyi"
                                            }
                                          })
                                        ]
                                      )
                                    : item.id == 2
                                    ? _c(
                                        "svg",
                                        {
                                          staticClass: "icon",
                                          attrs: {
                                            slot: "image",
                                            "aria-hidden": "true"
                                          },
                                          slot: "image"
                                        },
                                        [
                                          _c("use", {
                                            attrs: {
                                              "xlink:href": "#icon-dier"
                                            }
                                          })
                                        ]
                                      )
                                    : item.id == 3
                                    ? _c(
                                        "svg",
                                        {
                                          staticClass: "icon",
                                          attrs: {
                                            slot: "image",
                                            "aria-hidden": "true"
                                          },
                                          slot: "image"
                                        },
                                        [
                                          _c("use", {
                                            attrs: {
                                              "xlink:href": "#icon-disan"
                                            }
                                          })
                                        ]
                                      )
                                    : _c("em", { staticClass: "normal" }, [
                                        _vm._v(_vm._s(item.id))
                                      ])
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "td" }, [
                                  _vm._v(
                                    _vm._s(_vm.checkUserName(item.userName))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "td" }, [
                                  _vm._v(_vm._s(item.profit))
                                ])
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.rankList.length > 10,
                                  expression: "rankList.length > 10"
                                }
                              ],
                              staticClass: "view-more pointer",
                              on: { click: _vm.handleMore }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.ifSHowMore
                                      ? _vm.$t("300090")
                                      : _vm.$t("300089")
                                  ) +
                                  "\n              "
                              ),
                              _c("van-icon", {
                                attrs: {
                                  name: _vm.ifSHowMore
                                    ? "arrow-up"
                                    : "arrow-down"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            [
                              _c(
                                "van-empty",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.rankList.length == 0,
                                      expression: "rankList.length == 0"
                                    }
                                  ],
                                  staticClass: "custom-image",
                                  attrs: { description: _vm.$t("300108") }
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "icon",
                                      attrs: {
                                        slot: "image",
                                        "aria-hidden": "true"
                                      },
                                      slot: "image"
                                    },
                                    [
                                      _c("use", {
                                        attrs: { "xlink:href": "#icon-jilu1" }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.rankActiveId == "day",
                            expression: "rankActiveId == 'day'"
                          }
                        ],
                        staticClass: "block tip-message"
                      },
                      [_vm._v(_vm._s(_vm.$t("300087")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.rankActiveId == "total",
                            expression: "rankActiveId == 'total'"
                          }
                        ],
                        staticClass: "block tip-message"
                      },
                      [_vm._v(_vm._s(_vm.$t("300088")))]
                    )
                  ],
                  1
                )
              ])
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b6fca66", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b6fca66","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/rank.vue
// module id = Qat8
// module chunks = 0